<template>
  <!-- content included in DomainPopup component -->
  <div class="cmp-domain-popup-transfer ws-typography q-px-xl q-py-lg">
    <h6>
      {{ $t('domain_checker.transfer.title') }}
      <span class="text-green">{{ priceLabel }}</span>
    </h6>

    <p>
      <small>{{ transKey }}</small>
    </p>

    <div v-if="!shouldLogin && isEppCodeRequired" class="q-mt-xl">
      <ws-input
        v-model="eppCodeValue"
        :label="$t('domain_checker.transfer.input_placeholder')"
        path="transfer.eppCodeValue"
      />
      <ws-message path="properties.domain"></ws-message>
    </div>

    <div class="buttons-section row justify-between q-mt-xl">
      <!-- TODO: loggin in never triggered, why is it here? -->
      <ws-button
        v-if="shouldLogin"
        class="cy-add-transfer-button"
        :type="WsButtonEnum.Type.PRIMARY"
        @click="triggerLogin"
      >
        {{ $t('login.hf_template.to_login') }}
      </ws-button>

      <ws-button
        v-if="!shouldLogin"
        :loading="loading"
        :disable="loading"
        :type="WsButtonEnum.Type.PRIMARY"
        :size="WsButtonEnum.Size.MEDIUM"
        class="cy-add-transfer-button"
        @click="addTransferToCart"
      >
        {{ $t('domain_checker.transfer.buy_button') }}
      </ws-button>

      <ws-button
        :href="transferUrl"
        :type="WsButtonEnum.Type.SECONDARY"
        :size="WsButtonEnum.Size.MEDIUM"
        :element="WsButtonEnum.Element.A"
        target-blank
        icon="support"
      >
        {{ $t('domain_checker.transfer.about_link_text') }}
      </ws-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { redirect } from '@loopia-group/utils';
import { WsButton, WsButtonEnum } from '@loopia-group/components-vue2';
import WsInput from '@WS_Components/WsInput.vue';
import WsMessage from '@WS_Components/WsMessage.vue';
import type { StandaloneProduct } from '@/types';
import { getLoginUrl } from '../../../utilities';
import type { Domain } from '@/components/domain-checker/dc.types';
import config from '@/services/config.service';
import { addToCart } from '@/services/cart/cart-api.service';
import axios from '@/services/network.service';
import {ROUTENAMES} from '@/consts/const.enum';

@Component({
  components: {
    WsInput,
    WsButton,
    WsMessage,
  },
})
export default class DomainPopupTransfer extends Vue {
  @Prop()
  readonly domain!: Domain;
  @Prop(Boolean)
  readonly shouldLogin!: boolean;

  eppCodeValue = '';
  loading = false;
  transferUrl = config.transferUrl;
  isEppCodeRequired = true;
  WsButtonEnum = WsButtonEnum;

  mounted() {
    this.isEppCodeRequired = this.domain.isEppCodeForTransferRequired;
    this.getTransferInfoUrl();
  }

  get transKey() {
    return this.isEppCodeRequired
      ? this.$t('domain_checker.transfer.description')
      : this.$t('domain_checker.transfer.description_without_eppCode');
  }

  async getTransferInfoUrl() {
    try {
      const resp = await axios.get('knowledge-base/article/domain-transfer');
      this.transferUrl = resp.data.url;
    } catch (err) {
      this.$messageService.errorHandler(
        'domain-popup-transfer.knowlage-base.link'
      )(err);
    }
  }

  get transferPrice(): number {
    return this.domain?.price?.transferPrice || 0;
  }

  get priceLabel() {
    return this.transferPrice > 0
      ? this.$t('domain_checker.transfer.price', {
        price: this.$n(this.transferPrice, 'currency'),
      })
      : this.$t('domain_checker.transfer.free');
  }

  addTransferToCart() {
    this.loading = true;

    const product = {
      code: 'domain-transfer',
      name: `.${this.domain.tld} doména`,
      sellType: 'direct',
      price: {
        vatExcluded: this.domain.price?.transferPrice,
      },
      properties: {
        domain: this.domain.name,
        period: this.domain.period,
        eppCode: this.eppCodeValue,
      },
    } as StandaloneProduct;

    addToCart(product)
      .then(() => {
        this.$emit('hide-popup'); // done
      })
      .catch(this.$messageService.errorHandler('transfer.eppCodeValue'))
      .finally(() => (this.loading = false));
  }

  triggerLogin() {
    redirect(getLoginUrl(this.$router, ROUTENAMES.DOMAIN_CHECKER));
    this.$emit('hide-popup');
  }
}
</script>

<style lang="scss" scoped>
.cmp-domain-popup-transfer {
  > .buttons-section
    > a.q-btn.ws-button.q-btn.support-link
    ::v-deep
    > .q-btn__wrapper {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
